import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import Player from '@vimeo/player';
import axios from 'config/axios';
import Header from 'components/Header';
import Tabs from 'components/Tabs';

import './index.css';

function Lectures() {
    const [courses, setCourses] = useState(null);
    const [courseIndex, setCourseIndex] = useState(0);
    const [lectureGroupOpen, setLectureGroupOpen] = useState(null);
    const [currentLecture, setCurrentLecture] = useState(null);
    const [player, setPlayer] = useState(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [maxScrollHeight, setMaxScrollHeight] = useState(0);

    const lecturesRef = useRef(null);

    useEffect(() => {
        axios.get(`tutors/courses/`)
            .then(res => {
                setCourses(res.data.courses);
                // console.log(res.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (courses) {
            setLectureGroupOpen(null);
            setCurrentLecture(null);
        }
    }, [courseIndex]);

    useEffect(() => {
        if (currentLecture) {
            if (player) {
                player.loadVideo(currentLecture.videoUrl);
            }
            else {
                setPlayer(new Player('vimeoPlayer', {
                    url: currentLecture.videoUrl
                }));
            }
        }
        else {
            if (player) {
                player.destroy().then(() => setPlayer(null));
            }
        }
    }, [currentLecture]);

    useEffect(() => {
        if (lecturesRef.current) {
            const handleResize = () => {
                const rect = lecturesRef.current.getBoundingClientRect();
  
                setMaxScrollHeight(rect.height);
            }

            handleResize();

            window.addEventListener('resize', handleResize);
            
            return () => {
                window.removeEventListener('resize', handleResize);
            }
        }
    }, [courses, lectureGroupOpen]);

    useEffect(() => {
        const page = document.getElementById('page');

        const handleScroll = () => {
            if (page.scrollTop < maxScrollHeight) {
                setScrollPosition(page.scrollTop);
            }
        }

        page.addEventListener('scroll', handleScroll);
        
        return () => {
            page.removeEventListener('scroll', handleScroll);
        }
    }, [maxScrollHeight]);

    if (courses === null) return <></>;

    return (
        <>
            <Helmet>
                <title>
                    Video Lectures - Test Center Admin
                </title>
            </Helmet>
            <Header title='Video Lectures' />
            <Tabs
                tabs={courses.map(course => course.name)}
                tabIndex={courseIndex}
                onSelect={courses.map((_course, c) => () => setCourseIndex(c))}
            />
            <div className='lectures' ref={lecturesRef}>
                <div className='lectures__lectures'>
                    {courses[courseIndex].lectureGroups.map((lectureGroup, lectureGroupIndex) => (
                        <React.Fragment key={lectureGroup.name}>
                            <div
                                className='lectures__lectureGroup'
                                onClick={() => setLectureGroupOpen(prevLectureGroupOpen => (
                                    prevLectureGroupOpen === lectureGroupIndex ? null : lectureGroupIndex
                                ))}
                            >
                                <h4 className='lectures__lectureGroupTitle'>
                                    {lectureGroup.groupNumber}. {lectureGroup.name}
                                </h4>
                                {lectureGroupOpen === lectureGroupIndex
                                    ? <MdExpandLess className='lectures__lectureGroupExpandIcon' />
                                    : <MdExpandMore className='lectures__lectureGroupExpandIcon' />
                                }
                            </div>
                            {lectureGroupOpen === lectureGroupIndex &&
                                <div className='lectures__lectureGroupLectures'>
                                    {lectureGroup.lectures.map(lecture => (
                                        <div
                                            className={currentLecture?.id === lecture.id
                                                ? 'lectures__lecture--current'
                                                : 'lectures__lecture'
                                            }
                                            key={lecture.id}
                                            onClick={() => setCurrentLecture(lecture)}
                                        >
                                            <p className='lectures__lectureTitle'>{lecture.name}</p>
                                        </div>
                                    ))}
                                </div>
                            }
                        </React.Fragment>
                    ))}
                </div>
                <div className='lectures__lectureVideo'
                    style={{
                        transform: `translateY(${scrollPosition}px)`,
                        transition: 'transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)'
                    }}
                >
                    <div className='lectures__lectureVideoContainer'>
                        <div id='vimeoPlayer'></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Lectures;